const initialState = {
  popupVisible: true,
  modalDate: null,
};

const serviceAlertReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SERVICE_ALERT_POPUP_VISIBLE":
      return {
        ...state,
        popupVisible: action.payload.popupVisible,
      };
    case "SET_SERVICE_ALERT_MODAL_DATE":
      return {
        ...state,
        modalDate: action.payload.modalDate,
      };
    case "INIT_SERVICE_ALERT":
      return {
        popupVisible: true,
        modalDate: null,
      };
    default:
      return state;
  }
};

export default serviceAlertReducer; 